<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre3"><span id="Seite_11" title="[S. 11]"></span></p>
<h2 class="nobreak" id="Die_Alt-Pfarrkoechin">Die Alt-Pfarrköchin</h2>
</div>
<p class="calibre3"><span>„F</span>räulein Elisabeth“ und die Lene hausten jetzt schon bald zwei Jahre
zusammen im kleinsten Häuschen des Dörfchens, das zum Ausgeding der
Lene gehörte. Beide waren aus dem Dorf Rupertsweiler gebürtig, beide
hatten in einem Pfarrhof gedient. Die Lene als Magd, nur eigentlich
mehr für den Viehstall angestellt, auswärts, draußen in der Ebene.</p>
<p class="calibre3">Fräulein Elisabeth war Pfarrköchin beim Vorgänger des jetzigen
Dorfpfarrers bis zu dessen Tod.</p>
<p class="calibre3">Arm war die Pfarre gewesen, in der der Herr der Lene amtiert hatte,
ihr Lohn war gering, und nach dem Tod des Geistlichen erhielt sie
eine Rente von monatlich 15 Mark. Damit zog sie sich, 60 Jahre alt,
in das Häuschen zurück, das ihr bei der Erbteilung der Geschwister
als Ausgeding zugefallen war. Besser war’s ihrer Freundin Elisabeth
gegangen.</p>
<p class="calibre3">Die Pfarre war aus Klosterzeiten noch reich<span id="Seite_12" title="[S. 12]"></span> dotiert, und als bald nach
der Rückkunft der Lene auch der Dorfpfarrer starb, konnte Fräulein
Elisabeth, so wurde sie in ihrer Würde als Pfarrköchin allgemein
von den Dörflern angeredet, auf ein sorgenloses Alter rechnen; sie
hatte nahe an 100 Mark im Monat zu verzehren. Sie zog zur Lene ins
Häuschen, und da sie die Rüstigere war, mit ihren 52 Jahren, gesund
und frisch, besorgte sie auch das kleine Gärtchen, worin wuchs, was
sie zum Lebensunterhalt brauchten. Und sie behielt die Kirchenwäsche
auch unter dem Nachfolger ihres Herrn in ihrer Pflege, das gab ihr
außer der Ehre auch noch ein ganz nettes Sümmchen im Monat. Die neue
Pfarrköchin konnte überhaupt gegen die „Fräulein Elisabeth“ nicht
aufkommen. Das Zieren der Altäre an den Festtagen, keine verstand so
wie sie immer neue künstliche Blumenformen zu erfinden aus Wachs und
Stoff, die Ausschmückung der Straßen und Brunnen bei den öffentlichen
Prozessionen, alles gedieh nur unter ihrer Oberaufsicht, davon war
Fräulein Elisabeth überzeugt, und der Pfarrer und die Dörfler fügten
sich der Ansicht. Und der alte Meßner, der eigentlich lieber seinem
Schneiderhandwerk nachging, war erst recht damit einverstanden,<span id="Seite_13" title="[S. 13]"></span> daß
ihm nur die Dienste blieben, die eben von Frauen nicht versehen werden
durften. Nur die neue Pfarrköchin wollte nicht in die Lage der Dinge
sich fügen, bis jetzt stand sie aber allein mit ihrer Meinung, und
was sie auch nur vorgeschlagen hatte, war immer zum Übel ausgefallen.
Einmal hatte sie’s durchgesetzt, daß zur Auferstehungsfeier
Öllämpchen aufgestellt worden waren ums heilige Grab herum, statt der
Wachskerzchen, die Fräulein Elisabeth immer angebracht hatte. Bevor
aber die Prozession am heiligen Grabe angekommen war, fingen die
Lämpchen an fürchterlich zu prusten und zu spritzen, und die Flämmchen
erloschen jämmerlich im Wasser. „Ja die Fräulein Martha kennt eben
unsere Verhältnisse noch nicht,“ meinte mit betrübtem Kopfschütteln
Fräulein Elisabeth, die mit den Dörflern gern hochdeutsch sprach, „die
hat halt denkt, es geht so geschwind, wie in der Stadt, und da hat
sie halt mit dem Öl sparen wollen, sie isch überhaupt arg tüchtig und
sparsam.“ Die Fräulein Martha schwor hoch und teuer, daß sie genug Öl
eingefüllt habe, um die ganze Nacht zu reichen; gegen die Tatsache,
daß die Lämpchen ausgegangen waren, konnte sie<span id="Seite_14" title="[S. 14]"></span> nicht ankämpfen,
und die Dörfler spotteten und schimpften, und der Fräulein Martha
Behauptung, daß Fräulein Elisabeth Wasser nachgegossen habe, heimlich,
wurde von den wenigsten geglaubt. Und als nun gar am Fronleichnamstag
die Stufe des Altars am Pfarrhaus, den die Neue allein hergerichtet
hatte, unter dem Pfarrer einbrach, als er die Monstranz aufstellen
wollte, da wurde sie selber verzagt und tat lange Zeit nichts mehr
ohne den Rat ihrer erfahrenen Vorgängerin. Und so hätte die Fräulein
Elisabeth ganz glücklich leben können als Alt-Pfarrköchin, wenn sie
nur mit der Lene besser ausgekommen wäre. Sie war doch eigentlich
aus „purer Gutmütigkeit“ in das kleine Häuschen zur Lene gezogen,
weil „der arme Tschole“ sonst so ganz verlassen gewesen wäre; mit den
paar Pfennigen hätte sie ja doch nicht leben können, nur durch ihren
Beitrag zum Haushalt ging die Sache einigermaßen, und sie besorgte
doch den Garten — die Setzlinge bekam sie überall her geschenkt — so
hatten sie Gemüse in Hülle und Fülle. Aber die Lene wollte auch wieder
nicht recht einsehen, daß es ohne Fräulein Elisabeth nicht gegangen
wäre, sondern tat ganz so, als<span id="Seite_15" title="[S. 15]"></span> wäre die Fräulein Elisabeth nicht die
„Öberschte“ des Dörfchens, gleich nach dem geistlichen Herrn. „Du bisch
doch lang gnua Pfarrköchin gsi, i mein alls, du könnsch jetz au der
Fräuli Martha Platz gä,“ wiederholte sie immer wieder, wenn sie hörte,
wie Fräulein Elisabeth mit dem Meßner beratschlagte über die „äußeren
Kirchenangelegenheiten“. „Was hätsch au du gsait, wenn di Vorgängeri
grad so gsi wär un di nit dra glosse hätt,“ fragte sie ärgerlich.
Aber Fräulein Elisabeth fuhr auf und meinte in ihrer explosiven Art:
„I tua’s doch zur größeren Ehre Gottes, weil d’Fräulein Martha ja
alles hintere für macht, meinsch denn i hätt nit gern mi Ruah! I han
lang gnua gschafft, i tät gern usruha, aber sie verschtoht jo nint,
wenn i’s nit mach, glingt jo nix wie’s si soll, denk doch nur an die
Blamage mit de Öllämpli. I müßt mi ja vor unserem Herrgott und de liebe
Heilige schämme.“ — Und es schlug dem Faß den Boden aus, als die Lene
nach einer solchen Rede einmal zur Antwort brummte: „I mein alls, dini
Kerzli hätte au nit brennt, wenn mer sie vorher ins Wasser tunkt hätt.“
Danach sprachen die Beiden überhaupt nicht mehr miteinander, außer
wenn<span id="Seite_16" title="[S. 16]"></span> Besuch da war, denn nach außen ließen sie sich nichts merken,
das waren sie ihrer Stellung schuldig. Nur ein Gemeinsames gab’s noch,
das sie immer wieder zusammenführte: ihre Furcht vor Gewittern. Die
Lene fürchtete sich einfach, schlicht und recht wie ein frommes Kind,
sie zündete ihre geweihte Wachskerze an bei jedem Gewitter, schloß
Tür und Läden und betete den Rosenkranz. Fräulein Elisabeth war aber
zu ihrem Unglück gebildet. Sie hatte einmal eine Abhandlung über
Gewitter gelesen, und da war ihr hängen geblieben, daß „ein Gewitter
am liebsten in einen feindlichen Pol schlägt“. Und in der populären
Abhandlung war das so schön verdeutlicht worden, daß Fräulein Elisabeth
ganz genau wußte: „Feindschaft zieht Gewitter an“. Und da das mit dem,
was ihr ihr Gewissen sagte, vom Zorn Gottes gegen Menschen, die in
Feindschaft leben, so gar genau übereinstimmte, vermehrte ihr „Wissen“
nur noch ihre Angst. Wenn Gewitterwolken aufstiegen, wurde die kleine
lebhafte Person noch unruhiger und fahriger als sonst und hantierte mit
fieberhaftem Fleiß im Haus herum. Beim ersten Donner zieht sie sich
aber in ihr Schlafzimmer zurück, zündet auch die<span id="Seite_17" title="[S. 17]"></span> geweihte Wachskerze
an und holt den Rosenkranz aus der Tasche; aber lang hält sie’s nicht
allein im Zimmer aus. Sie klopft an das Schlafkämmerchen der Lene und
tritt zögernd auf das „Herein“ mit ihrer Wachskerze über die Schwelle.
„Lene, hänn Ihr was gege mi uf em Herze?“ ist ihre erste Frage. Die
Lene läßt sich im Beten nicht stören, sie schüttelt nur mit dem Kopfe.
„I mein alls, mer wänn zsamme bete,“ sagt Fräulein Elisabeth. Die Lene
betet ruhig weiter. Beim Absatz angelangt, sagt sie: „Stoh it so an der
Türe, hock di abi.“ Fräulein Elisabeth setzt sich dicht neben die Lene
auf die schmale Ofenbank im Zimmerwinkel. „I bin am zweite Gsätzli vum
Schmerzhafte,“ sagt sie dann auffordernd. Trocken erwidert die Lene:
„Wenn de mit bette willsch, i bi am vierte vum Trostreiche.“ Fräulein
Elisabeth gibt es einen Ruck, aber ein neuer Donner macht sie gefügig,
und sie spricht das Gesetzle mit der Lene weiter. Der erste Rosenkranz
ist zu Ende, aber das Gewitter dauert fort. „Waisch Lene, wenn i alls
so a weng heftig bin, i mein’s nie nit bös; gell mer wänn üs vertrage
wieder,“ fängt Fräulein Elisabeth nochmal an auf die Lene einzureden.<span id="Seite_18" title="[S. 18]"></span>
Die nickt und meint: „I ha nix gegen di, ’s isch mer recht, wem mer
üs vertrage.“ Mit erleichtertem Herzen fängt Fräulein Elisabeth nun
den Schmerzhaften an, und die Lene gibt die Antwort. Und so beten
sie in schöner Eintracht weiter, bis das Gewitter ausgetobt hat oder
fortgezogen ist, und zwei, drei Tage lang herrscht dann noch im kleinen
Häuschen Friede und Verträglichkeit.</p>
<p class="calibre3">Gewöhnlich ist der Meßner der Störenfried. Ist’s alte Gewohnheit oder
Freigebigkeit von Fräulein Elisabeth, oder traut er wirklich der neuen
Pfarrköchin keinen Sinn für Kirchenangelegenheiten zu, er kommt nach
wie vor mit seinen Anliegen zu Fräulein Elisabeth. Trifft er zufällig
die Lene allein in dem Häuschen an, so schickt ihn die gewöhnlich fort
mit einem: „Gehnt doch zur Fräuli Martha, die verschtoht des grad so
guat.“ Erfährt das Fräulein Elisabeth, so droht sie der armen Lene
mit allen Strafen der Hölle. „Du waisch, was des für a Sünd isch,
wenn mer jemand verhindert, a guts Werk z’tu. Wenn i unserm Herrgott
z’Ehre mich abschaff, wo doch suscht er grad in Unehre kumme tät, mit
dere ungeschickte Trine, i wüßt<span id="Seite_19" title="[S. 19]"></span> nit, was für a Straf groß gnug wär
für die, die des verdienschtlich Werk hindere wolle.“ Aber die Lene
blieb verstockt: „Blos nit, was di nit brennt, hätt mer mei Mutter
immer gsait un wenn’s d’Fraile Martha nit recht macht, muß sie des mit
unserem Herrgott ausmache, aber di Sach isch des jetzt amol nimmi, un
doderbi blieb i.“ Das war Anfang und Ende ihrer Rede, und Fräulein
Elisabeth gab es auf, sie zu bekehren.</p>
<p class="calibre3">Nun nahte aber dem kleinen Dörfchen ein Ereignis: zum erstenmal wieder
seit 18 Jahren sollte eine Primiz gefeiert werden. Ein Rupertsweiler
Kind war zum Priester geweiht worden und wollte seine erste heilige
Messe in der Kirche seiner Heimat feiern. Er war der Sohn vermöglicher
Bauern, und so freute sich das ganze Dorf, galt es doch nicht nur den
geistlichen Segen, den die erste heilige Messe eines Neupriesters
allen Anwesenden und dem ganzen Dorfe bringt; man wußte, daß auch die
irdische Freude zu ihrem Recht kommen würde. Festessen, Ständchen und
was noch alles stand zu erwarten. Fräulein Elisabeth triumphierte. Die
letzte heilige Primiz war unter ihrer Leitung<span id="Seite_20" title="[S. 20]"></span> glänzend verlaufen, und
ohne sie würde es auch diesmal einfach nicht zu machen sein. Fräulein
Martha hatte sie auch wirklich um Rat gefragt wegen der „geistlichen
Braut“ des Neupriesters, und von da an schlug Fräulein Elisabeth
ihr Hauptquartier im Pfarrhof auf und herrschte und regierte wie zu
ihrer Glanzzeit. Die Länge und Anzahl der Kranzgewinde, die Breite
und Höhe der Triumphbogen, durch die der Neupriester vom Elternhause
nach der Kirche schreiten sollte, die Inschriften aus der Bibel in
der Kirche und an den Bögen, die wählte sie mit besonders feinen
persönlichen Anspielungen, alles bestimmte sie, die Musikstücke auf dem
Zug zur Kirche und beim Ständchen sogar diktierte sie dem Leiter der
Dorfkapelle. Das Kissen, auf dem die geistliche Braut des Neupriesters
den Myrtenkranz tragen sollte, nähte Fräulein Elisabeth aus weißem
Atlas mit schönen Spitzen, und das Kränzchen besorgte sie in der nahen
Stadt, und der geistlichen Braut, einem zehnjährigen Mädele, zeigte
sie mit unermüdlicher Geduld, wie sie in ihrem weißen Kleidchen vor
dem Priester herschreiten sollte, wie sie das Kissen mit dem Kränzchen
tragen sollte, das ja nicht herunterfallen<span id="Seite_21" title="[S. 21]"></span> dürfte: „Das wär a gar
a böses Zeichen für die Reinheit vom hochwürdige Herr Neupriester,
aber dodervon verstehst du nix“; und wie und wo sie während der Feier
am Altar stehen mußte. Nur über das Zieren des Altars, an dem der
Neupriester zelebrieren sollte, brach eine Meinungsverschiedenheit
aus. Im Pfarrgarten blühten Hunderte von prächtigen weißen Lilien, und
Fräulein Martha, die ein poetisches Gemüt war, meinte, einen schöneren
Schmuck als Lilien, das Sinnbild der Reinheit und Unschuld, könnte
man nicht finden, und viel schöner als künstliche Blumen würden diese
Lilien wirken. Fräulein Elisabeth, die „fürs Symbolische“ war, beharrte
aber bei ihrem Plan, den Altar mit Weinreben zu schmücken. „Die Traube
ghöre zum Meßopfer, die hän a gar a bsondere geheimnisvolle Bedeutung,
und unser Heiland spricht nie von de Arbeiter im Blumengarte mit Lilie,
aber von de Arbeiter im Weinberg des Herrn, un ’s letschtemal hän i au
Weintrube gnomme, und unser seliger Herr hät in der Festpredigt vom
‚geistliche Weinstock‘ predigt, un dös war gar arg schön und rührend.
Von dene Lilie wüßt i nix z’sage, ’s stoht grad nur:<span id="Seite_22" title="[S. 22]"></span> ‚Sie säen nicht
und ernten nicht, und unser Vater ernährt sie doch‘, un i mein alls,
so brucht der jung hochwürdig Herr keiner z’werde, ’s isch besser,
er hat der Weinstock vor Auge, der erquickt der Menschen Herz. Und
außerdem hän mer nachher alli Kopfschmerze von dem strenge Gschmack
von dene Lilie.“ Aber Fräulein Martha ergab sich den schönen Gründen
nicht: „Vo wege dem Gschmack kan mer ja d’Staubfäde rauspfetze, no
schmeckt mer ga nit meh, un wenn der hochwürdige Herr Neupriester si
Lebtig Lilie vor Auge hät un so rein und unschuldig lebt, wie die
Blumen auf dem Felde, so wird unser Herrgott au z’friede sei, un i mein
alls, mer sotte doch d’Lilie nä.“ „Wenn Ihr alls besser mache wollt,
nu so machet’s halt,“ fuhr Fräulein Elisabeth auf. Sie schüttelt die
Tannenreisig vom Kränzeln von sich ab, holt ihr Kopftuch und bindet es
scheinbar gelassen um: „Also da bin i ja überflüssig, i wasch mei Händ
in Unschuld. Ihr wisset ja viel besser wie ich, wie a Primiz gefeiert
werden muß, machet au alles recht schön. B’hüt Gott beieinander.“ Und
bevor die verblüffte Pfarrköchin viel sagen konnte, war sie zur Tür
draußen und eilte zum Meßner. Bei<span id="Seite_23" title="[S. 23]"></span> diesem ihrem vertrauten Freund, der
in ihr immer noch so etwas wie die rechtmäßig regierende Pfarrköchin
sah, weinte sie erst ihre Kränkung recht aus, und der bestärkte sie
nur in ihrer Meinung: „Die Fräule Marthe hät halt au gar kei Sinn
fürs christliche Symbolium, he jo, für ä Erstkommunion, do ka mer
minswege Liliä näme, aber für ä Priester, do sin doch Weirebe halt au
viel beditungsvoller.“ „Un krank werde mer alli werde von dem starke
Gschmack. Aber des gschieht ere recht, dere eigensinnige Person der,“
schürte Fräulein Elisabeth weiter, „lasset nur alli Fenschter zua;
so a schöne Tag, der Ehretag vum ganzen Dorf, a so verderben mit dem
sündhafte Eigesinn! Wenn nur a paar ohnmächtig wäre täte, des tät ere
grad recht gschäh, i kann’s nit ändere, wenn mi nur unser Herrgott
nit stroft, daß i des gschehe laß — aber i kann’s nit ändere. ’s
gäb grad Unfriede un Skandal fürs ganz Dorf, zugredet han i ere in
christlicher Lieb grad gnug, i han mi so schon verdemütigt gnua, daß
i ganzi Täg unter ihrem Bfehl im Pfarrhaus garbeitet ha, i han’s halt
im liebe Heiland aufgopfert, aber jetzt muß i’s halt go lo, wie’s
goht. Ihr were<span id="Seite_24" title="[S. 24]"></span> sehne, ’s gibt a Unglück — aber i wasch mei Händ in
Unschuld — aber wie gsagt, sorget derfür, daß Türe und d’Fenschter
zua sin, wenn’s a paare so recht schlecht wäre tät von dem starken
Gschmack, vielleicht sicht sie dann ehnder ei, wie Unrecht sie ghabt
hat, so eigensinnig z’si un mir grad in allem z’wider z’handle. ’s isch
jo grad a guats Werk, wenn mer dere verstockte Person zur Einsicht
verhilft.“ Und der Küster meinte: „Jo grad a guats Werk tuat mer,“ und
versprach dafür zu sorgen, daß alles schön geschlossen sei. Fräulein
Elisabeth ging nun zur Lene ins Häuschen, zog Hut und Jacke an und
marschierte, ohne eine weitere Erklärung abzugeben als: „I han no
ebbes für d’Primiz z’bsorge“, nach der nahen Stadt. Als sie zurückkam,
zeigte sie ihren Einkauf nicht, sondern schloß das kleine Paket in die
Schublade ihres Sekretärs, ein Erbstück von ihrem Pfarrer, in dem sie
ihre Sparkassenbücher und Papiere aufbewahrte. — Am Tag darauf, am
Vortag der Feier, schickte Fräulein Martha wiederholt nach Fräulein
Elisabeth. Da bis jetzt alles durch ihre Hände gegangen war, fehlte
sie jetzt wirklich an allen Ecken und Enden. Beim dritten Boten ließ
sie sich auch erbitten und gab<span id="Seite_25" title="[S. 25]"></span> alle gewünschte Auskunft, ging auch
in den Pfarrhof und half die Lilien abschneiden und in die Vasen
richten auf dem Altar. Niemand merkte ihr ihren Groll an, nur daß sie
bei jeder, auch der unbedeutendsten, Handreichung erst fragte: „Wänn
Ihr’s au so habe? Isch’s Euch so recht, Fräulein Martha?“ wirkte etwas
beängstigend auf die Zuhörer. Der Abend kam heran, der Neupriester
hatte vom „Trippel“ seines Vaterhauses aus gedankt für das Ständchen,
das die Dorfmusikanten ihm gebracht. Hatte allen und jedem, der danach
verlangt, die Hand gedrückt und den scheu-vertraulichen Gruß mancher
früheren Spielgenossin mit priesterlicher Würde erwidert. Allmählich
kam das Dörfchen zur Ruhe in Erwartung des morgigen Festes. Kaum hatte
früh die Betglocke geläutet und die ersten Böllerschüsse waren gelöst
worden, eilte Fräulein Elisabeth in die Kirche, noch einen letzten
Blick auf den Altar zu werfen, ob auch nichts fehle. Zu Hause hatte
sie das kleine Paket aus dem Sekretär geholt, es ausgewickelt und drei
Fläschchen daraus entnommen, die sie in ihre Tasche versenkte. In der
Kirche ging sie zunächst hinter den Hochaltar. Sie mußte wohl<span id="Seite_26" title="[S. 26]"></span> an den
Vasen noch etwas geordnet haben; auf dem Fußboden um den Altar und auf
dem Teppich davor waren feuchte Flecke zu sehen. Auch die Lehnstühle
für den Neupriester und den assistierenden Priester befühlte sie noch
sorgfältig, und am Betschemel fand sie auch noch etwas zu wischen und
zurechtzurücken. Dann ging sie noch die mit rotem Tuch behangenen Bänke
entlang, die für die Eltern und Verwandten des Neupriesters aufgestellt
waren, und nun schien sie befriedigt zu sein mit ihrem Werk, mit
einem so freudigen Gesicht hob sie ihre Nase in die Luft und atmete
den üppigen Geruch der Lilien ein. Sie hatte sich entschieden damit
ausgesöhnt, warum hätte sie sonst so glücklich gelacht? Merkwürdig
war’s, wie der Geruch von Minute zu Minute stärker zu werden schien,
nicht nur nach Lilien, nach allen möglichen und unmöglichen Blumen
schien es zu duften. Recht mit Wohlbehagen sog Fräulein Elisabeth die
Luft ein.</p>
<p class="calibre3">Nun dröhnten die zweiten Böllerschüsse, und die Glocken fingen an
zu läuten. Fräulein Elisabeth verschwand mit einem eiligen Knix
vor dem Tabernakel aus der Kirche. Gleich würden jetzt<span id="Seite_27" title="[S. 27]"></span> die ersten
Kirchgänger kommen. Jetzt ging der Pfarrer aus dem Pfarrhaus fort, um
den Neupriester aus dem Elternhaus abzuholen. Draußen vor der Kirche
verwandelte sich das freudige Gesicht von Fräulein Elisabeth zu einem
scheu ängstlichen. Es war ein schwüler Augustmorgen, noch ziemlich
klar in der Höhe; aber am Horizont ballten sich schwere weiße Wolken
zusammen. „Wenn die no lang so fortlüte und böllere, ziehe se uns
noch ’s schönst Gewitter her,“ murmelte sie vor sich hin, mit einem
ärgerlichen Blick nach der nahen Halde, wo die Mörser aufgestellt
waren. Sie eilte nach Hause, ihren Sonntagsstaat zu vervollständigen,
und fand zu ihrer Überraschung die Lene im Werktagskleid auf der
Ofenbank. „’s wird jo gli z’sammenlütte, bisch no nit fertig?“ fragte
sie erstaunt. Die Lene stöhnte: „’s reißt mer wieder in alle Glieder,
i mein alls, i kann’s nit vermache, in d’Kirche z’go, ’s muß hit no ä
Gwitter gä, i spür’s.“ — „Geh, schwätz nit,“ fuhr Fräulein Elisabeth
auf, „wo wird’s denn hit ä Gwitter gä, ’s isch jo blaue Himmel, un
überhaupt, unser Herrgott wird doch ä Primiz nit verderbe lo mit eme
Gwitter,“ beruhigte sie mehr sich als die Lene. Die beharrte:<span id="Seite_28" title="[S. 28]"></span> „So
Riße han i immer, wenn’s ä Gwitter git,“ und brachte die arme Fräulein
Elisabeth zur höchsten Unruhe mit dieser Starrköpfigkeit. Sie lief
schnell nochmal ins Gärtchen, von wo aus sie die Horizontlinie im
Westen sehen konnte, und, war’s nun Einbildung, oder ballten sich da
wirklich die Wolken schon dunkler und höher als vorhin? Aufgeregt
lief sie ins Haus zurück und holte die geweihte Wachskerze hervor. Da
dröhnten von neuem die Böllerschüsse durchs Tal, und bei jedem Knall
fuhr Fräulein Elisabeth zusammen und ballte die Fäuste vor Zorn. Jetzt
setzte sich der Zug in Bewegung, gleich würde der junge Geistliche vor
dem Altar stehen. Und wenn er nun krank würde von dem starken Geruch
— der Lilien? Ein Blick nach dem blauen Himmel über ihr gab ihr Mut:
„Waisch Lene, wenn’s hit ä Gwitter gäb — oder suscht was passiert —
grad ’s Fräule Martha wär schuld.“ — Die Lene sah ihre Freundin scharf
an. „Häsch wider emol ä schlechts Gwisse?“ fragte sie. — „Jetzt nei,
mit dir isch nimmi z’rede,“ ereiferte sich Fräulein Elisabeth, „i sag
der doch grad, i möcht hit nit des schlecht Gwisse vu der Fräule Martha
ha.“ „He jo, grad,“ antwortete<span id="Seite_29" title="[S. 29]"></span> gelassen die Lene, „aber ’s isch Zit
in d’Kirch,“ setzt sie noch hinzu und beobachtet gespannt die Miene
von Fräulein Elisabeth. Die zögert, und zwischen Tür und Fenster sucht
ihr Blick ängstlich fragend den Himmel. „Bruchst nit der Himmel so
az’luage, mei Reiße kenn i,“ sagt die Lene ein klein wenig boshaft,
„hit git’s a Gwitter, sell isch sicher.“ Fräulein Elisabeth wirft einen
wütenden Blick auf die Lene, nimmt Gebetbuch und Rosenkranz und eilt
aus dem Häuschen mit einem knappen: „B’hüt di Gott derweil.“ „Bet au
für mi“, ruft die Lene noch nach, und dann schmunzelt sie vergnügt vor
sich hin und vergißt ihr Reißen. „I mein alls, die fürcht hit unsere
Herrgott wieder ä mol extrig“, meint sie. Fräulein Elisabeth kommt
richtig zu spät, der Zug ist schon in der Kirche, eine betäubende
Duftwolke schlägt ihr entgegen. Sie bleibt zunächst unter der Empore
stehen, sie mag sich nicht durchdrängen zu ihrem gewohnten Sitz in den
ersten Reihen, aber die Dörfler machen ihr wie immer so bereitwillig
Platz, daß sie gegen ihren Willen doch nach vorne mehr geschoben wird,
als daß sie eigentlich ginge. So steht sie an der vierten Bank, der
Platz neben<span id="Seite_30" title="[S. 30]"></span> Fräulein Martha ist leer. Niemand hatte gewagt, trotz der
Überfüllung, ihr den wegzunehmen. Sie kniet nieder, macht mechanisch
das Kreuzzeichen, und dann wischt sie sich den Schweiß von der Stirne,
es ist unerträglich schwüle Luft in der Kirche. Nun schaut sie nach
dem Altar. Der Neupriester fährt sich eben auch mit dem Taschentuch
übers Gesicht. „Grad grün sieht er aus“, konstatiert sie innerlich.
Aber behaglich ist ihr nicht zumute, ein Blick auf ihre Nachbarin, die
auch sichtlich unruhig ist, frischt sie wieder ein wenig auf. Sie kann
nicht widerstehen, sie muß ihr zuflüstern: „Ein wenig schmeckt mer
d’Lilie doch no.“ Das arme Fräulein Martha ist viel zu unglücklich, um
zu protestieren. „Hätt i nur auf Sie ghorcht“, flüstert sie zurück.
Gar keine Freude macht dies Zugeständnis dem Fräulein Elisabeth.
Verstocktheit, über die sie sich so recht hätte ärgern können, wär
ihr lieber gewesen. Eifrig schlägt sie in ihrem Gebetbuch nach, und
in bunter Hast liest sie die Gebete: „Für unsere Feinde.“ „Bei einem
Gewitter.“ Fast unbeachtet gehen die Zeremonien am Altar an ihr
vorüber. Immer wieder studiert sie die Gesichter der Nebensitzenden<span id="Seite_31" title="[S. 31]"></span>
mit ängstlichen Augen, und dann sucht sie am gegenüberliegenden Fenster
das blaue Stückchen Himmel, das von ihrem Platz zu sehen ist. Jetzt
besteigt der Domherr aus der Stadt, der dem jungen Mitbruder die
Festrede halten will, die Kanzel. Ihr summt’s und brummt’s vor den
Ohren, und die Böllerschüsse, die nun die Verlesung des Evangeliums
verkünden, jagen ihr neue Schrecken ein. Jetzt geht hinter ihr eine
unruhige Bewegung durch die Menge. Eine Frau ist ohnmächtig geworden
und muß hinausgetragen werden. Fräulein Martha fängt an zu weinen und
greift verstohlen nach der Hand von Fräulein Elisabeth, die flüstert
fast zärtlich zurück: „Des isch d’Ufregung un d’Hitz, bildet Euch doch
nix ei.“ — Der Geistliche hat eine kleine Pause gemacht, bis alles
wieder ruhig ist, und nun spricht er weiter von den erhabenen Pflichten
eines Priesters, der ein Bote der Liebe und der Versöhnung sein soll
auf dieser Erde, ein geistiger Leiter für seine Schäflein auf dem Wege
zum Himmel. Fräulein Elisabeth hört die Worte kaum, denn das Stücklein
blauer Himmel, das ihr Trost war bis jetzt, ist verschwunden, grau
und dräuend<span id="Seite_32" title="[S. 32]"></span> steht eine Wolke hinter der hohen Scheibe. „Wenn jetzt a
Gwitter kommt“, fährt ihr durch den Sinn, „un in dere heiße Kirche,
bei dere Luft, ’s muß ja eischlage. Wenn der Meßner doch a einzigs
mal herschaue wollt, daß i em winke könnt, er soll Türe und Fenster
ufmache.“ „Wenn’s doch nur scho vorbi wär“, seufzt Fräulein Martha
neben ihr. Im selben Moment rollt ein ferner Donner durch die Kirche.
„Jesses, Maria und Joseph!“ entfährt es fast laut Fräulein Elisabeth,
und sie bekreuzt sich. Der Prediger ist zu Ende und erteilt seinem
neuen Amtsbruder und der Gemeinde den Segen. Alles kniet nieder, und
Fräulein Elisabeth flüstert voll Hast ihrer Nachbarin zu: „I bin jo an
allem Schuld! Ihr hän do nix uf em Herze gege mi? Gell it? Betet au für
mi.“ Fräulein Martha ist viel zu verstört selbst, um die Anklage recht
zu fassen, sie drückt nur ihrer Nachbarin die Hand und meint: „Jo, mer
wänn bete für enander.“ Endlich kommt der Meßner mit dem Klingelbeutel
an ihre Bank, und Fräulein Elisabeth winkt ihm und flüstert ihm zu:
„Machet doch au d’Fenster und d’Türe uf, mer verstickt ja.“ Der schaut
sie erstaunt an, nickt<span id="Seite_33" title="[S. 33]"></span> aber dann bedächtig, zwinkert mit den Augen
und meint: „Jo, der Pfarrer het’s au scho gsait, i han’s aber nit
tan.“ Fräulein Elisabeth flüstert dringender noch: „Machet ja alles
uf, was ufgoht, i bitt Euch.“ Und so geschieht’s auch, und alle atmen
erleichtert in dem frischen Luftzug auf, und mit glockenheller Stimme
intoniert der Neupriester am Altar das Gloria, und befreit stimmt die
Gemeinde mit ein. Alles verläuft schön und würdig, und als die Feier
zu Ende ist, stehen die alte und die neue Pfarrköchin noch lange vor
der Kirchentüre und beglückwünschen sich gegenseitig, wie schön alles
gegangen wäre. Fräulein Elisabeth läuft vor dem Festessen, an dem sie
natürlich teilnehmen will, schnell noch mal nach Hause, zu sehen, wie’s
der Lene geht. Und auf deren Frage, wie’s denn gewesen wäre, meint sie:
„Waisch, Lene, eis hab i mer vorgnomme hit, i will nie nix meh mit sone
Sache z’tun ha. D’Verantwortig isch z’groß, s’Fräule Martha hät mi grad
duert, wie die zittert un bebt hätt, wie’s einere ohnmächtig wore isch,
von wegen dem starke Gschmack vu de Lilie, nei des möcht i nit uf mim
Gwisse ha. I bi froh, daß i mei Ruah hab un loß gwiß<span id="Seite_34" title="[S. 34]"></span> d’Finger davo —
des han i mir globet.“ — „Jo, bis zum nächste Mol“, meinte halblaut
die Lene. Aber die Fräulein Elisabeth hörte es nicht, weil sie grad
drei leere Fläschchen in die hinterste Sekretärschublade verschloß.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?fcc742a6